// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1abyX","overflowing":"ReadFullNote_overflowing__2WO8N"};